import { Link } from 'react-router-dom';

export default function BookCallCTA({ className = '' }: { className?: string }) {
  return <Link to="/book" className={`w-full sm:w-auto inline-flex items-center justify-center min-h-[48px] px-8 py-3 rounded-md bg-[#d4a10d] hover:bg-[#c3950c] text-gray-950 font-semibold transition-colors ${className}`}>Book a Call</Link>;
}
